<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="row">
            <div class="col-8">
              <h2><span id="assign_type">Assign</span> <span name="ttype">{{ttype}}</span></h2>
            </div>
            <div class="col-4 text-right">
              <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon><span id="go_back">Go Back</span></a>
            </div>
          </div>
          <div v-if="selectedItems===null">

            <div>
              <selectbundles ref="selectedBundleModule" v-if="mode==='bundles'" v-show="users!==null"></selectbundles>
              <selectusers ref="selectedUserModule" v-if="mode==='groups'" v-show="users!==null" :mode="'2'" :backbutton="false" :notitle="true"></selectusers>
              <selectproducts ref="selectedProductModule" v-if="mode==='products'" v-show="users!==null"></selectproducts>
              <selecttrainingplans ref="selectedTPModule" v-if="mode==='trainingplans'" v-show="users!==null"></selecttrainingplans>
            </div>
            <div v-if="itempool!==null&&itempool.length===0">
              <span id="there_are_no">There are no</span> <span name="ttype">{{ttype}}</span> <span id="available_to_assign">available to assign</span>
            </div>
          </div>
          <div v-if="selectedItems!==null&&assignmentResults===null">
            <div class="row">
              <div class="col-12">
                <h4 name="confirm_assignment">Confirm Assignment</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <span id="this_will_assign_following">This Will Assign The Following</span> <b> <span name="ttype">{{ttype}}</span> ({{selectedItems.length}})</b>:<br />
                <span v-for="i in selectedItems">{{i.name}}<br /></span>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <span id="to_the_following">To the Following</span> <b><span id="users">Users</span> ({{users.length}})</b>:<br />
                <span v-for="u in users">{{u.Name}}<br /></span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <button class="btn btn-primary btn-medium" @click="doAssignment" name="confirm_assignment">Confirm Assignment</button>
              </div>
            </div>
          </div>
          <div v-if="assignmentResults!==null">
            <div class="row mt-2">
              <div class="col-12">
                <h3 id="assignment_results">Assignment Results</h3>
                <p id="successful_assignment">Successful assignments are logged in the group log</p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-4">
                <b id="user">User</b>
              </div>
              <div class="col-4">
                <b id="assigned">Assigned</b>
              </div>
              <div class="col-4">
                <b id="result">Result</b>
              </div>
            </div>
            <div v-bind:class="{'row':true, 'mt-1':true, 'isred':result.Result!=='OK'}" v-for="result in assignmentResults">
              <div class="col-4">
                {{result.Name}}
              </div>
              <div class="col-4">
                {{result.AssignName}}
              </div>
              <div class="col-4">
                {{ getTranslatedText(result.Result) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div><acfooter></acfooter>
  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"
  import selectbundles from "../../components/SelectBundles.vue"
  import selectusers from "../../components/SelectUsers.vue"
  import selectproducts from "../../components/SelectProducts.vue"
  import selecttrainingplans from "../../components/SelectTrainingPlans.vue"

  export default {
    name: 'Assign',
    components: { acheader, acfooter, groupsidebar, selectbundles, selectusers, selectproducts, selecttrainingplans },
    data() {
      return {
        assignmentResults: null,
        itempool: null,
        mode: this.$route.params.type,
        ttype: null,
        selectedItems: null,
        users: null,
        ParentGroupId: null
      }
    },
  methods: {
    getTranslatedText(text) {
      return Window.getTranslatedText ? Window.getTranslatedText(text) : text;
    },
      doAssignment() {
        var commands = [];
        var ar = [];

        for (var x = 0; x < this.users.length; x++) {
          var u = this.users[x];
          for (var y = 0; y < this.selectedItems.length; y++) {
            var i = this.selectedItems[y];
            ar.push({
              Name: u.Name,
              AssignName: i.name,
              Result: ""
            });

            if (this.mode === 'bundles') {
              if (commands.filter(p => p.Function === "AssignBundle" && p.Fields.BundleID === i.value && p.Fields.ClientID === u.ClientID).length === 0) {
                commands.push({
                  Operation: "Client",
                  Function: "AssignBundle",
                  Fields: {
                    ClientID: u.ClientID,
                    BundleID: i.value
                  }
                });
              }
            }
            if (this.mode === 'groups') {
              if (commands.filter(p => p.Function === "AddMemberToGroup" && p.Fields.LicensePoolGroupID === i.value && p.Fields.ClientID === u.ClientID).length === 0) {
                commands.push({
                  Operation: "LicensePool",
                  Function: "AddMemberToGroup",
                  Fields: {
                    LicensePoolGroupID: i.value,
                    LicensePoolID: this.sdata.activegroup.LicensePoolID,
                    ClientID: u.ClientID
                  }
                });
              }
            }
            if (this.mode === 'products') {
              if (commands.filter(p => p.Function === "AddProduct" && p.Fields.ProductID === i.productid && p.Fields.ClientID === u.ClientID).length === 0) {
                commands.push({
                  Operation: "Client",
                  Function: "AddProduct",
                  Fields: {
                    FromPoolID: this.sdata.activegroup.LicensePoolID,
                    ClientID: u.ClientID,
                    ProductID: i.productid,
                    LicenseType: i.type,
                    LicensePoolProductID: i.value
                  }
                });
              }
            }
            if (this.mode === 'trainingplans') {
              if (commands.filter(p => p.Function === "AddMemberToCurricula" && p.Fields.CurriculumID === i.value && p.Fields.ClientID === u.ClientID).length === 0) {
                commands.push({
                  Operation: "LicensePool",
                  Function: "AddMemberToCurricula",
                  Fields: {
                    LicensePoolID: this.sdata.activegroup.LicensePoolID,
                    ClientID: u.ClientID,
                    CurriculumID: i.value
                  }
                });
              }
            }
          }
        }

        if (commands.length > 0) {
          this.apiCommand(commands).then(r => {
            var cr = JSON.parse(r.CommandResult);
            for (var z = 0; z < cr.returnObjects.length; z++) {
              ar[z].Result = cr.returnObjects[z].returnObject;
            }

            this.assignmentResults = ar;
            setTimeout(Window.loadLanguageContent(this.ttype), 5000);
          })
        }
      },
      doneSelection(items) {

        for (var i of items) {
          switch (this.mode) {
            case 'bundles':
              i.name = i.BundleName;
              i.value = i.BundleID;
              break;
            case 'trainingplans':
              i.name = i.CurriculumName;
              i.value = i.CurriculumID;
              break;
            case 'products':
              i.name = i.ProductName;
              i.value = i.LicensePoolProductID;
              i.type = i.LicenseType;
              i.productid = i.ProductID;
              break;
          }
        }
        this.selectedItems = items;
        setTimeout(Window.loadLanguageContent(this.ttype), 5000);
      },
      groupsSelected() {
        this.selectedItems = this.$refs["selectedUserModule"].getData();
        setTimeout(Window.loadLanguageContent(this.ttype), 5000);
      },
      goBack() {
        this.$router.back();
      }
    },
    mounted() {
      this.doPage().then(r => {

        if (typeof JSON.parse(localStorage.getItem("sdata")).allgroups !== 'undefined' && JSON.parse(localStorage.getItem("sdata")).allgroups != null) {
          var GroupId = JSON.parse(localStorage.getItem("sdata")).allgroups.filter(function (entry) {
            return entry.ParentID == "00000000-0000-0000-0000-000000000000";
          });
          this.ParentGroupId = GroupId[0].LicensePoolGroupID;
        }

        this.bootstrapGroup(this.$route.params.id);
        var cmd = null;
        switch (this.mode) {
          case 'bundles':
            this.ttype = 'Bundles';
            cmd = {
              Operation: "LicensePool",
              Function: "GetBundles",
              Fields: {
                LicensePoolID: this.sdata.activegroup.LicensePoolID
              }
            };
            break;
          case 'groups':
            this.ttype = 'Groups';
            cmd = {
              Operation: "LicensePool",
              Function: "GetGroupSubGroups",
              Fields: {
                LicensePoolID: this.sdata.activegroup.LicensePoolID,
                GroupID: this.ParentGroupId //this.$route.params.id
              }
            };
            break;
          case 'products':
            this.ttype = 'Products';
            cmd = {
              Operation: "LicensePool",
              Function: "GetProducts",
              Fields: {
                LicensePoolID: this.sdata.activegroup.LicensePoolID,
                LanguageID: sessionStorage.getItem("userLanguageID")
              }
            };
            break;
          case 'trainingplans':
            this.ttype = 'Training Plans';
            cmd = {
              Operation: "LicensePool",
              Function: "GetCurricula",
              Fields: {
                LicensePoolID: this.sdata.activegroup.LicensePoolID
              }
            };
            break;
        }

        if (cmd !== null) {

          this.apiCommand([cmd]).then(r => {
            var cr = JSON.parse(r.CommandResult);
            this.itempool = JSON.parse(cr.returnObjects[0].returnObject);
            if (this.mode === 'products') {
              this.itempool = this.itempool.filter(p => p.LicensesNumber > 0);
            }

            if (this.itempool.length > 0) {
              if (this.mode === 'groups') {
                this.$refs["selectedUserModule"].setData("", [], null, [], this.itempool);
              }
              if (this.mode === 'bundles') {
                this.$refs["selectedBundleModule"].setData(this.itempool);
              }
              if (this.mode === 'products') {
                this.$refs["selectedProductModule"].setData(this.itempool);
              }
              if (this.mode === 'trainingplans') {
                this.$refs["selectedTPModule"].setData(this.itempool);
              }
              this.users = JSON.parse(localStorage.getItem("assigndata"));

            }
            setTimeout(Window.loadLanguageContent(this.ttype), 5000);

          });
        }

      });
    }
  }
</script>
